window.osMaps = window.osMaps || {};

const initOSMap = (block) => {
    const maps = block ? [block[0].querySelector(".bn-os-map > div")] : Array.from(
        document.querySelectorAll(".bn-os-map > div")
    );

    if (maps) {
        maps.forEach((mapContainer) => {
            if (mapContainer) {
                const latitude = parseFloat(mapContainer.dataset.latitude);
                const longitude = parseFloat(mapContainer.dataset.longitude);
                const zoom = parseInt(mapContainer.dataset.zoom, 13);
                const popupText = mapContainer.dataset.text;
                const hasMarker = mapContainer.dataset.marker;
                const markerUrl = mapContainer.dataset.markerUrl || null;
                const markerWidth = mapContainer.dataset.markerWidth ? parseInt(mapContainer.dataset.markerWidth, 10) : null;
                const markerHeight = mapContainer.dataset.markerHeight ? parseInt(mapContainer.dataset.markerHeight, 10) : null;
                let map = null;

                if(window.osMaps[mapContainer.id]) {
                    map = window.osMaps[mapContainer.id].map.setView([latitude, longitude], zoom)
                } else {
                    let container = L.DomUtil.get(mapContainer.id);
                    if (container != null) {
                        map = L.map(mapContainer.id).setView([latitude, longitude], zoom);
                    }
                }

                L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

                let iconOptions = {
                    draggable: false
                };

                if (hasMarker && markerUrl) {
                    iconOptions.icon = L.icon({
                        iconUrl: markerUrl,
                        iconSize: [markerWidth, markerHeight]
                    });

                    let marker = new L.Marker([latitude, longitude], iconOptions);
                    marker.addTo(map).bindPopup(popupText).openPopup();
                }

                window.osMaps[mapContainer.id] = {
                    map: map
                };
            }
        })
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        initOSMap();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/os-map', initOSMap);
});